import { render } from "./DiscountSelector.vue?vue&type=template&id=3e6c0123&scoped=true"
import script from "./DiscountSelector.vue?vue&type=script&lang=js"
export * from "./DiscountSelector.vue?vue&type=script&lang=js"

import "./DiscountSelector.vue?vue&type=style&index=0&id=3e6c0123&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e6c0123"]])

export default __exports__